import adComputed from "@/mixins/adComputed";

export default {
    mixins: [adComputed],
    methods: {
        insertSliderAd() {
            const rowCount = this.getCarPerRow - 1;
            const addProp = {isSlider: true, ad: true};
            if (this.carsInSliders && this.carsInSliders.length && this.allAd && this.allAd.length) {
                this.carsInSliders[1].cars.splice(rowCount, 0, {...addProp, ...this.allAd[0], adData: this.allAd[0]});

                const secondAd = this.allAd.length > 1 ? this.allAd[1] : this.allAd[0];
                this.carsInSliders[3].cars.splice(rowCount, 0, {...addProp, ...secondAd, adData: this.allAd[1]});
            }
        },
        insertAd(replace) {
            console.log("insertAd",replace);
            if (!this.allAd || this.allAd.length === 0) {
                return;
            }

            if (this.$device.tablet()) {
                this.insertSliderAd();
            }

            if (this.$device.desktop()) {
                this.insertSliderAd();
            }
            let insertIndex = [];
            let carsByFilter = this.carsByFilter;
            if (replace) {
                carsByFilter = this.carsByFilter.filter(e => !e.ad);
            }

            const firstPerCars = parseInt(this.getCarPerRow + ((this.getCarPerRow / 2) - 1));
            let perCars = parseInt((this.getCarPerRow * 5) + ((this.getCarPerRow / 2) - (this.getCarPerRow > 3 ? 1 : 0)));//this.ad.search_results_per_car || 20;
            const maxItems = this.allAd.length;


            carsByFilter.map((e, i) => {
                if (!replace && i < perCars) {
                    return e;
                }
                if (insertIndex.length === 0 && i > 0 && i % firstPerCars === 0) {
                    insertIndex.push(i > 25 ? i + 1 : i);
                } else if (i > 0 && (i - firstPerCars) % perCars === 0) {
                    insertIndex.push(i - insertIndex.length);
                }
                return e;
            });


            if (carsByFilter.length > 0 &&
                carsByFilter.length <= firstPerCars &&
                (this.getLastBannerIndex(carsByFilter) === 0 || this.getLastBannerIndex(carsByFilter) === null)) {

                insertIndex.push(carsByFilter.length);
            }

            let curItem = 0;
            insertIndex.map((e, i) => {
                if (i % maxItems === 0) {
                    curItem = 0;
                } else {
                    curItem++;
                }

                const diff = e - this.getLastBannerIndex(carsByFilter);

                if (diff >= (insertIndex.length === 1 ? firstPerCars - 1 : firstPerCars)) {
                    carsByFilter.splice(e, 0, {ad: true, ...{empty: true}});
                }

            });

            if (carsByFilter.length > 0 && carsByFilter.length < firstPerCars
                && this.getLastBannerIndex(carsByFilter)===null) {

                carsByFilter.push({ad: true, ...{empty: true}});
            }

            this.setData({
                field: 'moduleOldCars.cars.items',
                data: carsByFilter
            });

        },
        getLastBannerIndex(carsByFilter) {
            let maxVal = null;
            carsByFilter.map((e, i) => {
                if (e.ad) {
                    maxVal = i;
                }
            });
            return maxVal;
        }
    }
}